<template>
 
  <div class="">
    <div class="q-my-xxs q-py-xl q-px-xl bg-gray-3" v-if="$q.screen.lt.sm">
      <div class="row justify-between">
      <div class="text-h6 text-weight-bolder text-black">Survey Indeks Kepuasan Masyarakat</div>
      <div class="text-h6" style="font-size: 12px;">Beranda / <span class="text-secondary">Survey IKM</span></div>
      </div>
    </div>

    <div class="q-my-xxs q-py-xl q-px-xl text-center bg-grey-3" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="row justify-between">
      <div class="text-h6 text-weight-bolder text-black">Survey Indeks Kepuasan Masyarakat</div>
      <div class="text-h6" style="font-size: 12px;">Beranda / <span class="text-secondary">Survey IKM</span></div>
      </div>
    </div>

    <div class="row wrap justify-between items-start content-start">
        <!-- <div class="row"> -->
      <div class="col">
        <!-- .col -->
      </div>
      <div class="col-6 q-pa-lg">
        <form @submit.prevent="addData()">
        <div class="text-black" style="padding-bottom: 10px; font-size: 16px; font-weight: bold;">Nama Responden</div> 
        <q-input outlined v-model="form.nama" :dense="true" style="padding-bottom: 20px;" required />

        <div class="=text-black" style="padding-bottom: 10px; font-size: 16px; font-weight: bold;">Email</div> 
        <q-input outlined v-model="form.email" :dense="true" style="padding-bottom: 20px" required />

        <div class="=text-black" style="padding-bottom: 10px; font-size: 16px; font-weight: bold;">Umur</div> 
        <q-input outlined v-model="form.umur" :dense="true" type="number" style="padding-bottom: 20px" required />

        <div class="=text-black" style="padding-bottom: 10px; font-size: 16px; font-weight: bold;">Pendidikan Terakhir</div> 
        <q-input outlined v-model="form.pendidikan" :dense="true" style="padding-bottom: 20px" required />

        <div class="=text-black" style="padding-bottom: 10px; font-size: 16px; font-weight: bold;">Pekerjaan</div> 
        <q-input outlined v-model="form.pekerjaan" :dense="true" style="padding-bottom: 20px" required />

        <div class="=text-black text-justify" style="padding-bottom: 10px; font-size: 16px; font-weight: bold;">Bagaimana Pendapat Bapak/Ibu/Saudara (i) tentang kesesuaian persyaratan pelayanan dengan jenis pelayanannya pada BRIDA KONSEL ?</div> 
        <q-option-group :options="persyaratan" type="radio" v-model="form.persyaratan" style="padding-bottom: 20px" required  />

        <div class="=text-black text-justify" style="padding-bottom: 10px; font-size: 16px; font-weight: bold;">Bagaimana menurut Bapak/Ibu/Saudara (i) tentang kemudahan prosedur/ mekanisme pelayanan yang diberikan  pada BRIDA KONSEL ?</div> 
        <q-option-group :options="prosedur" type="radio" v-model="form.prosedur" style="padding-bottom: 20px" required  />

        <div class="=text-black text-justify" style="padding-bottom: 10px; font-size: 16px; font-weight: bold;">Bagaimana pendapat  Bapak/Ibu/Saudara (i) tentang kecepatan pelayanan yang diberikan  pada BRIDA KONSEL ?</div> 
        <q-option-group :options="pelayanan" type="radio" v-model="form.pelayanan" style="padding-bottom: 20px" required  />

        <div class="=text-black text-justify" style="padding-bottom: 10px; font-size: 16px; font-weight: bold;">Bagaimana  menurut Bapak/Ibu/Saudara (i)  dalam hal Biaya/Tarif Pelayanan  pada BRIDA KONSEL, apakah sudah sesuai dengan biaya yang di tetapkan ?</div> 
        <q-option-group :options="tarif" type="radio" v-model="form.tarif" style="padding-bottom: 20px" required  />

        <div class="=text-black text-justify" style="padding-bottom: 10px; font-size: 16px; font-weight: bold;">Bagaimana menurut Bapak/Ibu/Saudara (i)  kesesuaian antara hasil pelayanan yang di berikan  BRIDA KONSEL dengan ketentuan yang di tetapkan / permintaan awal ?</div> 
        <q-option-group :options="ketentuan" type="radio" v-model="form.ketentuan" style="padding-bottom: 20px" required  />

        <div class="=text-black text-justify" style="padding-bottom: 10px; font-size: 16px; font-weight: bold;">Bagaiman menurut Bapak/Ibu/Saudara (i) kemampuan/Kompetensi petugas pelayanan BRIDA KONSEL dalam hal memberikan pelayanan ?</div> 
        <q-option-group :options="kompetensi" type="radio" v-model="form.kompetensi" style="padding-bottom: 20px" required  />

        <div class="=text-black text-justify" style="padding-bottom: 10px; font-size: 16px; font-weight: bold;">Bagaimana pendapat  Bapak/Ibu/Saudara (i) tentang sikap, tingkah laku (kesopanan dan keramahan) petugas pelayanan BRIDA KONSEL dalam memberikan pelayanan ?</div> 
        <q-option-group :options="sikap" type="radio" v-model="form.sikap" style="padding-bottom: 20px" required  />

        <div class="=text-black text-justify" style="padding-bottom: 10px; font-size: 16px; font-weight: bold;">Bagaimana menurut Bapak/Ibu/Saudara (i) kesesuaian antara Pelayanan yang di dapat dengan Hasil Maklumat Pelayanan (Standar Pelayanan) yang di tetapkan pada BRIDA KONSEL ?</div> 
        <q-option-group :options="maklumat" type="radio" v-model="form.maklumat" style="padding-bottom: 20px" required  />

        <div class="=text-black text-justify" style="padding-bottom: 10px; font-size: 16px; font-weight: bold;">Bagaimana pendapat Bapak/Ibu/Saudara (i)  mengenai kemudahan menyampaikan pengaduan, saran dan masukan di BRIDA KONSEL ?</div> 
        <q-option-group :options="pengaduan" type="radio" v-model="form.pengaduan" style="padding-bottom: 20px" required  />

        <q-btn :loadig="btn_add" color="secondary" size="lg" style="width:100%; margin-top:20px" label="Kirim"  @click="addData()" />
        
        </form>
      </div>
      <div class="col">
        <q-dialog v-model="mdl_open">
      <q-card>
        <q-card-section>
          <div class="text-h6">Notifikasi</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          Berhasil Input Data
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
        <!-- .col -->
      </div>
    <!-- </div>  -->
    </div>

  </div>     
</template>

<script>
export default {
  name: 'foto',
  data() {
         return {
            persyaratan: [
              { label: 'Tidak Sesuai', value: 'Tidak Sesuai', color: 'red' },
              { label: 'Kurang Sesuai', value: 'Kurang Sesuai', color: 'yellow' },
              { label: 'Sesuai', value: 'Sesuai', color: 'green' },
              { label: 'Sangat Sesuai', value: 'Sangat Sesuai' }
            ],
            prosedur: [
              { label: 'Tidak Mudah', value: 'Tidak Mudah', color: 'red' },
              { label: 'Kurang Mudah', value: 'Kurang Mudah', color: 'yellow' },
              { label: 'Mudah', value: 'Mudah', color: 'green' },
              { label: 'Sangat Mudah', value: 'Sangat Mudah' }
            ],
            pelayanan: [
              { label: 'Tidak Cepat', value: 'Tidak Cepat', color: 'red' },
              { label: 'Kurang Cepat', value: 'Kurang Cepat', color: 'yellow' },
              { label: 'Cepat', value: 'Cepat', color: 'green' },
              { label: 'Sangat Cepat', value: 'Sangat Cepat' }
            ],
            tarif: [
              { label: 'Sangat Mahal', value: 'Sangat Mahal', color: 'red' },
              { label: 'Cukup Mahal', value: 'Cukup Mahal', color: 'yellow' },
              { label: 'Murah', value: 'Murah', color: 'green' },
              { label: 'Gratis', value: 'Gratis' }
            ],
            ketentuan: [
              { label: 'Tidak Sesuai', value: 'Tidak Sesuai', color: 'red' },
              { label: 'Kurang Sesuai', value: 'Kurang Sesuai', color: 'yellow' },
              { label: 'Sesuai', value: 'Sesuai', color: 'green' },
              { label: 'Sangat Sesuai', value: 'Sangat Sesuai' }
            ],
            kompetensi: [
              { label: 'Tidak Kompeten', value: 'Tidak Kompeten', color: 'red' },
              { label: 'Kurang Kompeten', value: 'Kurang Kompeten', color: 'yellow' },
              { label: 'Kompeten', value: 'Kompeten', color: 'green' },
              { label: 'Sangat Kompeten', value: 'Sangat Kompeten' }
            ],
            sikap: [
              { label: 'Tidak Sopan dan Ramah', value: 'Tidak Sopan dan Ramah', color: 'red' },
              { label: 'Kurang Sopan dan Ramah', value: 'Kurang Sopan dan Ramah', color: 'yellow' },
              { label: 'Sopan dan Ramah', value: 'Sopan dan Ramah', color: 'green' },
              { label: 'Sangat Sopan dan Ramah', value: 'Sangat Sopan dan Ramah' }
            ],
            maklumat: [
              { label: 'Buruk', value: 'Buruk', color: 'red' },
              { label: 'Cukup', value: 'Cukup', color: 'yellow' },
              { label: 'Baik', value: 'Baik', color: 'green' },
              { label: 'Sangat Baik', value: 'Sangat Baik' }
            ],
            pengaduan: [
              { label: 'Tidak Ada', value: 'Tidak Ada', color: 'red' },
              { label: 'Ada Tapi Tidak Berfungsi', value: 'Ada Tapi Tidak Berfungsi', color: 'yellow' },
              { label: 'Berfungsi Kurang Maksimal', value: 'Berfungsi Kurang Maksimal', color: 'green' },
              { label: 'Dikelola Dengan Baik', value: 'Dikelola Dengan Baik' }
            ],
      data_load: false,
      form : {
                    id : '',
                    nama : '',
                    umur : '',
                    email : '',
                    umur : '',
                    pendidikan : '',
                    pekerjaan : '',
                    persyaratan : '',
                    prosedur : '',
                    pelayanan : '',
                    tarif : '',
                    ketentuan : '',
                    kompetensi : '',
                    sikap : '',
                    maklumat : '',
                    pengaduan : '',
                    createAt : '',
                },
      persistent : false,

      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
      mdl_open: false,
      btn_add: false,
    };
    },
    methods: {
			// getView: function() {
            //     this.cek_load_data = true;
            //     fetch(this.$store.state.URL_TEMA + "view", {
            //         method: "POST",
            //         headers: {
            //         "content-type": "application/json",
            //         },
            //             body: JSON.stringify({
            //             data_ke: this.page_first,
            //             cari_value: this.cari_value
            //         })
            //     })
            //         .then(res => res.json())
            //         .then(res_data => {
            //             this.list_data = res_data.data;
            //             this.page_last = res_data.jml_data;
            //             this.cek_load_data = false;
            //             console.log(res_data);
            //     });
            // },
          getView: function() {
        this.mdl_open = true;
        },
            addData : function() {

            console.log(this.form);
            fetch(this.$store.state.URL_IKM + "addData", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify(this.form)
            }).then(res_data => {
                // this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
                console.log(res_data);
                this.getView();
            });
            },


            // ================== PAGINASI ====================
                alertku: function(type, title) {
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
                },

                btn_prev : function(){
                        this.cek_load_data = true;
                    if(this.page_first>1){
                        this.page_first--
                    }else{
                        this.page_first = 1;
                    }
                    this.getView();
                },

                btn_next : function(){
                    
                    if(this.page_first >= this.page_last){
                        this.page_first == this.page_last
                    }else{
                        this.page_first++;
                    }
                    this.getView();
                },

                cari_data : function(){
                    this.page_first = 1;
                    this.getView();
                },
                // onFileSelected: function(event) {
                // this.form.file = event.target.files[0];
                // },
                convert_tgl: function(dateString) {
                    var date = new Date(dateString);
                    var getBulan = date.getMonth() + 1; var bulan = '';
                    if (getBulan == '1') {bulan = 'Januari'} 
                    else if(getBulan == '2') {bulan = 'Februari'}
                    else if(getBulan == '3') {bulan = 'Maret'}
                    else if(getBulan == '4') {bulan = 'April'}
                    else if(getBulan == '5') {bulan = 'Mei'}
                    else if(getBulan == '6') {bulan = 'Juni'}
                    else if(getBulan == '7') {bulan = 'Juli'}
                    else if(getBulan == '8') {bulan = 'Agustus'}
                    else if(getBulan == '9') {bulan = 'September'}
                    else if(getBulan == '10') {bulan = 'Oktober'}
                    else if(getBulan == '11') {bulan = 'November'}
                    else if(getBulan == '12') {bulan = 'Desember'}



                    return date.getDate() + " " + bulan + " " + date.getFullYear();
                    // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
                }
		},
		mounted() {
            // this.getView();

		},

}
</script>
